'use client';

import ErrorComponents from '../components/shared/ErrorComponents';

const InternalServerError = () => {
  return <ErrorComponents error="500" />;
};

export default InternalServerError;
